import React from 'react'
import PropTypes from 'prop-types'
import { DisplayRestrictiveLists } from 'components/DueDiligence/Questions'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import { Expansible } from 'components/Expansible'
import BuildRestrictions from 'components/ExpandedInfo/BgcExpansible/BuildRestrictions'

import styles from './styles'

function BuildRestrictionsReviewInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      <Expansible title="Respostas do formulário Due Diligence">
        {addKeyToObjectsArray(reviewData?.related_form_answers)?.map(
          (answer) => (
            <DisplayRestrictiveLists
              key={answer.key}
              questionData={answer?.answer_object}
            />
          ),
        )}
      </Expansible>
      {reviewData?.extra_questions && (
        <Expansible title="Respostas às questões automáticas relacionadas à pergunta">
          <AutomaticQuestions questions={reviewData?.extra_questions} />
        </Expansible>
      )}

      <Expansible title="Dados do Bureau relacionados ao assessor">
        <BuildRestrictions restrictionsData={reviewData.restriction_data} />
      </Expansible>
    </div>
  )
}

BuildRestrictionsReviewInfo.propTypes = {
  reviewData: PropTypes.shape({
    created: PropTypes.string,
    updated: PropTypes.string,
    uuid: PropTypes.string,
    decisions: PropTypes.arrayOf(
      PropTypes.shape({
        created: PropTypes.string,
        updated: PropTypes.string,
        uuid: PropTypes.string,
        area_decision: PropTypes.string,
        reviewer_id: PropTypes.number,
        reviewer: PropTypes.shape({
          uuid: PropTypes.string,
          email: PropTypes.string,
          display_name: PropTypes.string,
        }),
        reviewer_comment: PropTypes.string,
        current_review_area: PropTypes.string,
      }),
    ),
    result: PropTypes.string,
    current_review_area: PropTypes.string,
    reason: PropTypes.string,
    related_form_answers: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        answer_object: PropTypes.object,
      }),
    ),

    extra_questions: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        text: PropTypes.string,
        occurrence: PropTypes.shape({
          reason: PropTypes.string,
          classification: PropTypes.string,
        }),
        answered: PropTypes.bool,
        subject: PropTypes.string,
      }),
    ),
    type: PropTypes.string,
    restriction_data: PropTypes.shape({
      uuid: PropTypes.string,
      created: PropTypes.string,
      updated: PropTypes.string,
      consists: PropTypes.bool,
      restrictions: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string,
          list_name: PropTypes.string,
          last_update: PropTypes.string,
          pseudonyms: PropTypes.string,
          entry_date: PropTypes.string,
          exit_date: PropTypes.string,
          subject_name: PropTypes.string,
        }),
      ),
    }),
  }).isRequired,
}

export default BuildRestrictionsReviewInfo
